import React, { useEffect, useState } from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import UserRole from "../../helpers/role";
import swal from "sweetalert";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap";
import moment from "moment";
import $, { map } from "jquery";
import CommonIcon from "../../helpers/icons";
import WarningComponent from "../../helpers/modal";
import Toaster from "../../helpers/toaster";
import PaginationComponent from "../../helpers/Pagination";
import API from "../../helpers/endpointservice";
import axios from "axios";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import DateFnsUtils from "@date-io/date-fns";
import "date-fns";
import LoaderVisible from "../../helpers/loader";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { logoutFunction } from "../../custom/logoutFunction";
import Selected from "react-select";

const styles = {
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: "noWrap",
    textOverflow: "ellipsis",
  }),
};

class UpcomingTainings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: "",
      isRequestFailed: false,
      isRequestLoader: false,
      height: window.innerHeight,
      isMobile: false,
      isRadioMobile: false,
      isSmallMobile: false,
      iswebMobile: false,
      apply_for: "",
      versionLogList: [],
      editScreen: false,
      upcomingtrainingView: {},
      upcomingList: [],
      userId: 0,
      sortBy: "",
      isSortAscending: true,
      currentPage: 1,
      perPage: 20,
      pageCount: 0,
      upcomingtrainingView: {},
      courseCodeList: [],
      employeeList: [],
      coursecodeEmpty: false,
      startDateEmpty: false,
      endDateEmpty: false,
      vacancyEmpty: false,
      isupdate: false,
      employeeEmpty: false,
      id: 0,
      courseId: 0,
      courseCode: "",
      courseTitle: "",
      startDate: "",
      isActive: true,
      isNonConsecutiveDates: false,
      isNonConsecutiveDatesView: false,
      endDate: "",
      comments: "",
      applyComments: "",
      category1Name: "",
      category2Name: "",
      trainingHours: "",
      skills: "",
      skillId: 0,
      vendorName: "",
      courseDiscription: "",
      trainingDiscription: "",
      today: "",
      employeeName: "",
      employeeCode: "",
      employeeId: "",
      selectedEmployeeName: [],
      selectedEmployeeId: [],
      trainingId: 0,
      enrolledStatus: "",
      selectCourse: "",
      selectEmployee: "",
      searchInputData: {
        trainingRequestId: "",
        courseCode: "",
        status: "",
        skills: "",
        skillId: 0,
        vendorName: "",
        startDate: null,
        endDate: null,
        activeStatus: "",
        trainingStatus: "",
      },
      isActiveTraining: true,
      validationMsg: false,
      isSearch: false,
      employeeNameEmpty: false,
      selectEmployeeName: [],
      employeeNameList: [],
      vendorList: [],
      selectVendorName: [],
      skillsList: [],
      selectSkillsName: [],
      managerSupervisorName: [],
      isvalid: false,
      pageNewCount: false,
      startDateView: "",
      endDateView: "",
      additionalDateView: [],
      vacancy: 0,
      totalVacancy: 0,
      remainingVacancy: 0,
      courseCodeHeader: "",
      selectedOption: null,
      eligible: false,
      eligibleMsg: "",
      additionalDates: [null],
      additionalErrors: [],
      additionalDatesDuplicate: false,
      isRemovePopUp: true,
    };
  }

  componentDidMount() {
    let user = localStorage.getItem("UserId");
    this.state.userId = parseInt(user);
    this.state.currentUser = localStorage.getItem("Role").split(",")[0];
    this.state.today = new Date()?.toISOString()?.split("T")[0];
    this.setState({});
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
    this.GetUpcomingTrainingList();
    this.getEmployeeName();
    this.GetCoursesList();
    this.getVendorList();
    this.getSkillList();
    $("body").removeClass("scrollhide");
    // this.getAdminCenterUserId(JSON.parse(localStorage.getItem("userDataDecode"))?.email)
    // this.GetEmployeeList();
  }
  // getAdminCenterUserId = (email) => {
  //     axios
  //     .get(`${API.GET_USER}?email=${email}`)
  //     .then((response) => {
  //       if (response?.status === 200) {
  //           this.state.adminCenterUserId = response.data.adminCenterUserId;
  //       }
  //     })
  //     .catch((error) => {
  //         logoutFunction(error?.response?.status);
  //       console.log(error);
  //     });
  //    }

  getSkillList = () => {
    axios
      .get(API.GET_SKILLS_TYPE)
      .then((response) => {
        if (response?.status === 200) {
          // this.setState({
          //     skillTypeList: response.data
          // })
          this.state.skillsList = response?.data?.map((skill) => {
            return {
              value: skill.id + "," + skill.skillName,
              label: (
                <>
                  {/* <img
                                src={VendorNameIcon}
                            /> */}
                  {/* <CommonIcon className="properties-img-2" fileName="skillIcon" /> */}
                  {/* &nbsp; */}
                  <span>{skill.skillName}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
      });
  };

  getVendorList = () => {
    axios
      .get(API.GET_VENDOR)
      .then((response) => {
        if (response?.status === 200) {
          this.state.vendorList = response?.data?.map((vendor) => {
            return {
              value: vendor.id + "," + vendor.vendorName,
              label: (
                <>
                  <span>{vendor.vendorName}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
      });
  };

  GetCoursesList = () => {
    let apiUrl = `${API.GET_COURSE_CODE}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.courseCodeList = res.data.map((course) => {
            return {
              value:
                course.courseId +
                "," +
                course.courseCode +
                "," +
                course.courseName,
              label: (
                <>
                  <span>{course.courseCode + " - " + course.courseName}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  GetEmployeeList = (trainingId) => {
    let apiUrl = `${API.GET_EMPLOYEES}?userId=${this.state.userId}&trainingId=${trainingId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.employeeList = res.data.map((course) => {
            return {
              value:
                course.employeeId +
                "," +
                course.employeeCode +
                "," +
                course.employeeName,
              label: (
                <>
                  <span>
                    {course.employeeName +
                      ` ${course.employeeCode ? "(" + course.employeeCode + ")" : ""}`}
                  </span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  GetEmployeeListAdmin = (trainingId) => {
    let apiUrl = `${API.GET_ADMIN_EMPLOYEE_LIST}&userId=${this.state.userId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.employeeList = res.data.map((course) => {
            return {
              value:
                course.id + "," + course.employeeCode + "," + course.userName,
              label: (
                <>
                  <span>
                    {course.userName +
                      ` ${course.employeeCode ? "(" + course.employeeCode + ")" : ""}`}
                  </span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  GetUpcomingTrainingList = () => {
    const { sortBy, isSortAscending, currentPage, perPage, userId } =
      this.state;
    let apiUrl = `${API.GET_UPCOMING_TRAINING_LIST}?userId=${userId}&sortBy=${sortBy}&isSortAscending=${isSortAscending}&pageNumber=${currentPage}&pageSize=${perPage}`;
    this.state.isRequestLoader = true;
    this.setState({
      isRequestFailed: false,
      perPage: perPage,
    });
    let searchValues = {
      requestId: this.state.searchInputData.trainingRequestId || null,
      skills: this.state.selectSkillsName?.value?.split(",")[1] || null,
      skillId: this.state.selectSkillsName?.value?.split(",")[0] || 0,
      vendorName: this.state.selectVendorName?.value?.split(",")[1] || null,
      // vendorName: this.state.searchInputData.vendorName || null,
      courseCode: this.state.searchInputData.courseCode || null,
      courseTitle: this.state.searchInputData.courseTitle || null,
      status: this.state.searchInputData.status || null,
      startDate:
        this.state.searchInputData.startDate?.toISOString()?.slice(0, 10) ||
        null,
      endDate:
        this.state.searchInputData.endDate?.toISOString()?.slice(0, 10) || null,
      activeStatus: this.state.searchInputData.activeStatus || null,
      trainingStatus: this.state.searchInputData.trainingStatus || null,
    };
    axios({
      method: "POST",
      url: apiUrl,
      data: this.state.isSearch ? searchValues : {},
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.isRequestLoader = false;
          this.setState({
            upcomingList: res.data.values,
            pageCount: res.data.totalCount,
            isRequestFailed: false,
            currentPage: res.data.currentPage,
            perPage: res.data.pageSize,
            isRequestFailed: false,
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  saveTrainingWithoutValidation = () => {
    let trainingDates = this.state.additionalDates
      .filter((date) => date !== null && date !== undefined && date !== "")
      .map((date) => moment(date).format("YYYY-MM-DD"));
    let dateSplit = this.splitDates(trainingDates);
    console.log(dateSplit);
    let apiUrl = `${API.SAVE_TRAININING_DETAILS}?userId=${this.state.userId}`;
    let data = {
      id: this.state.id,
      courseId: this.state.courseId,
      courseCode: this.state.courseCode,
      courseTitle: this.state.courseTitle,
      comments: this.state.comments,
      isNonConsecutiveDates: this.state.isNonConsecutiveDates,
      startDate: this.state.isNonConsecutiveDates
        ? dateSplit.startDate
        : moment(this.state.startDate).format("YYYY-MM-DD"),
      endDate: this.state.isNonConsecutiveDates
        ? dateSplit.endDate
        : moment(this.state.endDate).format("YYYY-MM-DD"),
      // startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
      // endDate: moment(this.state.endDate).format("YYYY-MM-DD"),
      vacancy: this.state.vacancy,
      selectedDates:
        dateSplit.selectedDates.length > 0 ? dateSplit.selectedDates : [],
      isActive: this.state.isActive ?? false,
    };
    this.setState({ isRequestLoader: true, isRequestFailed: false });
    let apiurl1 = `${API.IS_TRAINING_EXIST}?trainingId=${
      this.state.editScreen ? this.state.trainingId : 0
    }&courseId=${this.state.courseId}&startDate=${moment(
      data.startDate,
      // this.state.startDate
    ).format("YYYY-MM-DD")}&endDate=${moment(data.endDate).format(
      // ).format("YYYY-MM-DD")}&endDate=${moment(this.state.endDate).format(
      "YYYY-MM-DD",
    )}`;
    axios({
      method: "GET",
      url: apiurl1,
    }).then((response) => {
      if (response.data === false) {
        axios({
          method: "POST",
          url: apiUrl,
          data: data,
        })
          .then((res) => {
            if (res.status === 200) {
              this.setState({
                isRequestLoader: false,
                isRequestFailed: false,
              });
              this.GetUpcomingTrainingList();
              this.closeAddScreen();
              if (this.state.editScreen) {
                toast.success("Training edited successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  color: "#fff",
                });
              } else {
                toast.success("Training added successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  color: "#fff",
                });
              }
            }
          })
          .catch((error) => {
            logoutFunction(error?.response?.status);
            console.log(error);
            this.setState({ isRequestLoader: false });
            swal(
              "Error!",
              "Something went wrong. Please try again.",
              "warning",
            );
          });
      } else {
        this.setState({
          isRequestLoader: false,
        });
        toast.error(
          "The training is already registered with same start date and end date.",
          {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
          },
        );
      }
    });
  };

  saveUpcomingTraining = () => {
    let isvalid = this.validation();

    if (isvalid) {
      if (!this.state.isActive && this.state.editScreen) {
        this.setState({ isRequestLoader: true });
        let url = `${API.IS_TRAINING_ACTIVE}?trainingId=${this.state.id}`;
        axios({
          method: "GET",
          url: url,
        })
          .then((res) => {
            if (res.data === false) {
              this.saveTrainingWithoutValidation();
            } else {
              this.setState({ isRemovePopUp: false, isRequestLoader: false });
              let cancelPopup = new window.bootstrap.Modal(
                document.getElementById("CancelCourseScreen"),
              );
              cancelPopup.show();
              $("body").addClass("scrollhide");
              return;
            }
          })
          .catch((error) => {
            logoutFunction(error?.response?.status);
            console.log(error);
            this.setState({ isRequestLoader: false });
            swal(
              "Error!",
              "Something went wrong. Please try again.",
              "warning",
            );
          });
      } else {
        this.saveTrainingWithoutValidation();
      }
    } else {
      this.setState({ isRequestLoader: false });
    }
  };

  EligibleCandidate = () => {
    this.setState({
      isRequestLoader: true,
    });
    let apiUrl = `${API.POST_USER_ELIGIBLE_IN_OTHER_TRAINING}?userId=${this.state.userId}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: {
        trainingId: this.state.trainingId * 1,
        comments: this.state.applyComments,
        startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
        endDate: moment(this.state.endDate).format("YYYY-MM-DD"),
        users:
          this.state.apply_for?.toLowerCase() == "apply for me"
            ? [
                {
                  userId: this.state.userId,
                },
              ]
            : this.state.selectedEmployeeId.map((e) => {
                return {
                  userId: e,
                };
              }),
      },
    })
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            isRequestLoader: false,
            eligible: res.data?.status,
            eligibleMsg: res.data?.message,
          });
          if (res.data?.status == true) {
            this.validationManagerSupervisorPresent();
          } else {
            toast.error(res.data?.message);
          }
        } else {
          this.setState({ isRequestLoader: false });
        }
      })
      .catch(() => {
        this.setState({ isRequestLoader: false });
      });
  };

  applyTraining = () => {
    let valid = true;
    if (
      this.state.remainingVacancy === null ||
      this.state.remainingVacancy === undefined ||
      this.state.remainingVacancy === 0
    ) {
      toast.error("There is no vacancy for this training", {
        position: toast.POSITION.TOP_RIGHT,
        color: "#fff",
      });
      valid = false;
    }
    if (!this.state.isActiveTraining) {
      toast.error(
        "Not able to apply for this training. This training course is Inactive.",
        {
          position: toast.POSITION.TOP_RIGHT,
          color: "#fff",
        },
      );
      valid = false;
    }
    if (
      valid &&
      this.state.selectedEmployeeName.length <= this.state.remainingVacancy
    ) {
      if (this.state.apply_for === "Apply for others") {
        if (
          this.state.selectedEmployeeName.length === 0 ||
          this.state.selectEmployeeName === null ||
          this.state.selectEmployeeName === undefined
        ) {
          this.state.isvalid = false;
          this.setState({ employeeEmpty: true });
        } else {
          this.setState({ employeeEmpty: false });
          // this.EligibleCandidate();  //Commented based on the new changes - (no validation for date 0f training applied 19-01-2026)
          this.validationManagerSupervisorPresent();
          // console.log(this.state.eligible);
          // if (this.state.eligible) {
          //   this.validationManagerSupervisorPresent();
          // } else {
          //   toast.error(
          //     `This training is already applied for ${this.state.employeeName}`
          //   );
          // }
        }
      } else {
        this.setState({ isRequestLoader: true });
        // this.EligibleCandidate();
        this.validationManagerSupervisorPresent();
        // if (this.state.eligible) {
        //   this.validationManagerSupervisorPresent();
        // } else {
        //   toast.error(
        //     `This training is already applied for ${this.state.eligibleMsg}`
        //   );
        // }
      }
    } else {
      if (
        this.state.selectedEmployeeName.length > this.state.remainingVacancy
      ) {
        toast.error("The employee count is greater than available vacancy", {
          position: toast.POSITION.TOP_RIGHT,
          color: "#fff",
        });
      }
    }
  };

  validationManagerSupervisorPresent = () => {
    // this.state.isRequestLoader = true;
    this.setState({
      isRequestLoader: true,
    });
    let apiUrl = `${API.IS_SUPERVISOR_MANAGER_PRESENT}?userId=${this.state.userId * 1}`;
    axios({
      method: "POST",
      url: apiUrl,
      // data: this.state.employeeId ? [this.state.employeeId * 1] : this.state.selectedEmployeeId
      data:
        this.state.apply_for?.toLowerCase() == "apply for me"
          ? [this.state.userId]
          : this.state.selectedEmployeeId,
    })
      .then((response) => {
        if (response?.status === 200) {
          if (response.data?.length > 0) {
            if (this.state.apply_for === "Apply for me") {
              if (response.data.length == 2) {
                toast.error(
                  `The Supervisor and Manager is not assigned for you`,
                );
              } else if (response.data[0] == "manager") {
                toast.error(`The Manager is not assigned for you`);
              } else if (response.data[0] == "supervisor") {
                toast.error(`The Supervisor is not assigned for you`);
              }
            } else {
              if (response.data.length == 2) {
                toast.error(
                  `The Supervisor and Manager is not assigned for ${this.state.employeeName}`,
                );
              } else if (response.data[0] == "manager") {
                toast.error(
                  `The Manager is not assigned for ${this.state.employeeName}`,
                );
              } else if (response.data[0] == "supervisor") {
                toast.error(
                  `The Supervisor is not assigned for ${this.state.employeeName}`,
                );
              }
            }
            this.state.managerSupervisorName = response.data;
            this.setState({
              isRequestLoader: false,
            });
          } else {
            this.validationTrainingApplied();
          }
        } else {
          this.setState({
            isRequestLoader: false,
          });
        }
      })
      .catch((error) => {
        console.log("err");
        console.log(error);
        this.state.isRequestLoader = false;
      });
  };

  validationTrainingApplied = () => {
    this.setState({
      isRequestLoader: true,
    });
    if (this.state.apply_for === "Apply for others") {
      let apiurl = `${API.IS_TRAINING_APPLIED}?trainingId=${
        this.state.trainingId * 1
      }`;
      axios({
        method: "POST",
        url: apiurl,
        // data:this.state.employeeId ? [this.state.employeeId * 1] : this.state.selectedEmployeeId
        data:
          this.state.apply_for?.toLowerCase() == "apply for me"
            ? [this.state.userId]
            : this.state.selectedEmployeeId,
      })
        .then((response) => {
          if (response?.status === 200) {
            this.setState({
              isRequestLoader: false,
            });
            //this.state.isRequestLoader = false;
            if (response.data.status === false) {
              toast.error(
                `This training is already applied for ${this.state.employeeName}`,
              );
            } else if (response.data.status === true) {
              this.postApplyTraining();
            }
          }
          // this.setState({
          //   isRequestLoader: false
          // });
        })
        .catch(() => {
          this.setState({
            isRequestLoader: false,
          });
        });
    } else if (this.state.apply_for === "Apply for me") {
      let obj = [this.state.userId];
      axios
        .post(
          `${API.IS_TRAINING_APPLIED}?trainingId=${this.state.trainingId}`,
          obj,
        )
        .then((response) => {
          if (response?.status === 200) {
            if (response.data?.status === false) {
              if (response.data?.message) {
                toast.error(response.data?.message);
              }
              this.setState({
                isRequestLoader: false,
              });
            } else if (response.data?.status === true) {
              this.postApplyTraining();
            }
          } else {
            this.setState({
              isRequestLoader: false,
            });
          }
        })
        .catch(() => {
          this.setState({
            isRequestLoader: false,
          });
        });
    } else {
      this.postApplyTraining();
    }
  };

  postApplyTraining = () => {
    this.setState({
      isRequestLoader: true,
    });
    let apiUrl = `${API.APPLY_FOR_TRAINING}?userId=${this.state.userId}`;
    let data = {
      trainingId: this.state.trainingId * 1,
      comments: this.state.applyComments,
      startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
      endDate: moment(this.state.endDate).format("YYYY-MM-DD"),
      users:
        this.state.apply_for?.toLowerCase() == "apply for me"
          ? [
              {
                userId: this.state.userId,
              },
            ]
          : /* this.state.employeeId ? [this.state.employeeId * 1] :*/ this.state.selectedEmployeeId.map(
              (e) => {
                return {
                  userId: e,
                };
              },
            ),
    };
    //this.state.isRequestLoader = true
    this.setState({ isRequestFailed: false });
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((res) => {
        if (res.status === 200) {
          this.setState({ isRequestFailed: false, isRequestLoader: false });
          //this.state.isRequestLoader = false;
          this.GetUpcomingTrainingList();
          this.closeApplyTraining();
          this.closeAddScreen();
          if (res.data.code === 200 && res.data.status === false) {
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
          }
          if (res.data.code === 200 && res.data.status === true) {
            // this.applyreset();
            toast.success("Training applied successfully", {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
          }
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal(
          "Error when applying the training.",
          "Please try again.",
          "warning",
        );
      });
  };

  validation = () => {
    let isvalid = true;
    if (
      this.state.courseCode === "" ||
      this.state.courseCode === null ||
      this.state.courseCode === undefined
    ) {
      isvalid = false;
      this.setState({ coursecodeEmpty: true, isRequestLoader: false });
    }
    if (!this.state.isNonConsecutiveDates) {
      if (
        this.state.startDate === "" ||
        this.state.startDate === null ||
        this.state.startDate === undefined
      ) {
        isvalid = false;
        this.setState({ startDateEmpty: true, isRequestLoader: false });
      }
      if (
        this.state.endDate === "" ||
        this.state.endDate === null ||
        this.state.endDate === undefined
      ) {
        isvalid = false;
        this.setState({ endDateEmpty: true, isRequestLoader: false });
      }
    }
    if (
      this.state.vacancy === 0 ||
      this.state.vacancy === null ||
      this.state.vacancy === undefined
    ) {
      isvalid = false;
      this.setState({ vacancyEmpty: true, isRequestLoader: false });
    }
    if (this.state.isNonConsecutiveDates) {
      const newErrors = [];
      this.state.additionalDates.forEach((date, index) => {
        if (date === null || date === undefined || date === "") {
          isvalid = false;
          newErrors.push("This field is required");
        } else {
          const current = new Date(date);
          const start = new Date(this.state.startDate);
          const end = new Date(this.state.endDate);
          // if (start && end && (current <= start || current >= end)) {
          //   isvalid = false;
          //   newErrors.push("Date must be between start and end date");
          // } else {
          //   newErrors.push("");
          // }
          newErrors.push("");
        }
      });
      if (
        new Set(
          this.state.additionalDates.filter(
            (d) => d !== null && d !== undefined && d !== "",
          ),
        ).size !==
        this.state.additionalDates.filter(
          (d) => d !== null && d !== undefined && d !== "",
        ).length
      ) {
        isvalid = false;
        this.setState({ additionalDatesDuplicate: true });
      } else {
        this.setState({ additionalDatesDuplicate: false });
      }
      this.setState({ additionalErrors: newErrors });
    }
    return isvalid;
  };

  // applyTrainingValidation = () => {
  //     let isvalid = true;
  //     if (this.state.apply_for === "Apply for others") {
  //         if (this.state.searchInputData.employeeName === "" || this.state.searchInputData.employeeName === null || this.state.searchInputData.employeeName === undefined) {
  //             isvalid = false;
  //             this.setState({ employeeEmpty: true });
  //         }
  //     }
  //     return isvalid;
  // }

  fetchPaginationList = (currentPage, perPage) => {
    this.setState(
      {
        currentPage: currentPage,
        perPage: perPage,
        isSortAscending: this.state.isSortAscending,
        sortBy: this.state.sortBy,
      },
      () => {
        this.GetUpcomingTrainingList();
      },
    );
  };

  sortTable = (sortBy, isSortAscending) => {
    this.state.currentPage = 1;
    this.state.pageNewCount = !this.state.pageNewCount;
    this.setState(
      {
        sortBy: sortBy,
        isSortAscending: !isSortAscending,
      },
      () =>
        this.GetUpcomingTrainingList(
          this.state.currentPage,
          this.state.perPage,
        ),
    );

    // this.setState({}, () => {
    //     this.GetUpcomingTrainingList(this.state.currentPage, this.state.perPage)
    // })
  };

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 750) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 490) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 400) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = false;
    }

    this.state.height = window.innerHeight;
    this.setState({});
  };

  handleDateChange = (event, field) => {
    const inputDate = event;
    if (field === "startDate") {
      this.state.startDate = inputDate
        ? moment(inputDate).format("DD-MMM-YYYY")
        : "";
      this.state.endDate = null;
      this.state.startDateEmpty = false;
    }
    if (field === "endDate") {
      this.state.endDate = inputDate
        ? moment(inputDate).format("DD-MMM-YYYY")
        : "";
      this.state.endDateEmpty = false;
    }
    this.setState({}, () => {});
  };

  handleChange = (e, type, field) => {
    const { name, value } = e.target;
    if (name == "isNonConsecutiveDates") {
      this.setState((prevData) => ({
        ...prevData,
        [name]: value,
        additionalDates: [null],
        additionalErrors: [""],
        startDate: "",
        endDate: "",
        startDateEmpty: false,
        endDateEmpty: false,
      }));
      return;
    }
    if (type === "date") {
      const inputDate = e.target.value;
      const formattedDate = inputDate
        ? moment(inputDate).format("DD-MMM-YYYY")
        : "";
      this.setState((prevData) => ({
        ...prevData,
        [name]: formattedDate,
        [field]: false,
      }));
    } else {
      this.setState((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  handleVacancyChange = (e) => {
    const vacancy = e.target.value * 1;
    const numberRegex = /^\d+$/;
    if (numberRegex.test(vacancy) == true) {
      this.setState({ vacancy: vacancy });
    }
  };

  addDate = () => {
    this.setState({
      additionalDates: [...this.state.additionalDates, null],
      additionalErrors: [...this.state.additionalErrors, ""],
    });
  };

  removeDate = (index) => {
    const newDates = [...this.state.additionalDates];
    const newErrors = [...this.state.additionalErrors];
    newDates.splice(index, 1);
    newErrors.splice(index, 1);
    this.setState({ additionalDates: newDates, additionalErrors: newErrors });
  };

  handleAdditionalDateChange = (date, index) => {
    const formattedDate = date ? moment(date).format("DD-MMM-YYYY") : null;
    const newDates = [...this.state.additionalDates];
    const newErrors = [...this.state.additionalErrors];
    newDates[index] = formattedDate;
    newErrors[index] = ""; // reset error when date is selected
    this.setState({ additionalDates: newDates, additionalErrors: newErrors });
  };

  mergeAndSortDates = (startDate, endDate, selectedDates = []) => {
    const allDates = [startDate, endDate, ...(selectedDates || [])].filter(
      Boolean,
    ); // remove null / undefined

    // Remove duplicates + sort
    const uniqueSortedDates = [...new Set(allDates)]
      .sort((a, b) => new Date(a) - new Date(b))
      .map((date) => moment(date).format("DD-MMM-YYYY"));

    return uniqueSortedDates;
  };

  splitDates = (dateArray = []) => {
    if (!Array.isArray(dateArray) || dateArray.length === 0) {
      return {
        startDate: null,
        endDate: null,
        selectedDates: [],
      };
    }

    const sorted = [...dateArray].sort((a, b) => new Date(a) - new Date(b));

    // 👉 If only one date
    if (sorted.length === 1) {
      return {
        startDate: sorted[0],
        endDate: sorted[0],
        selectedDates: [],
      };
    }

    // 👉 If multiple dates
    return {
      startDate: sorted[0],
      endDate: sorted[sorted.length - 1],
      selectedDates: sorted.slice(1, sorted.length - 1),
    };
  };

  UpcomingDetails = (item) => {
    this.setState({ isupdate: true });
    let apiUrl = `${API.GET_TRAININING_DETAILS_ID}?trainingId=${item.id}&userId=${this.state.userId}`;
    // this.setState({ isRequestLoader: true, isRequestFailed: false, trainingId: item.id, status: "Enrolled" });
    this.setState({
      isRequestLoader: true,
      isRequestFailed: false,
      trainingId: item.id,
      enrolledStatus: item.isEnrolled,
    });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          if (this.state.currentUser.toLowerCase() == "admin") {
            this.GetEmployeeListAdmin(res.data.id);
          } else {
            this.GetEmployeeList(res.data.id);
          }
          let additionalDates = this.mergeAndSortDates(
            res.data.startDate,
            res.data.endDate,
            res.data.selectedDates,
          );
          this.setState(
            {
              editScreen: true,
              id: res.data.id,
              courseCode: res.data.courseCode,
              courseCodeHeader: res.data.courseCode,
              // selectCourse :   this.state.courseCodeList?.filter(
              //     (c) => parseInt(c.value?.split(",")[0]) === res.data?.courseId
              //   )[0],
              selectCourse: {
                label: res.data.courseCode + " - " + res.data.courseTitle,
                value: res.data.courseCode + " - " + res.data.courseTitle,
              },
              courseTitle: res.data.courseTitle,
              courseId: res.data.courseId,
              category1Name: res.data.category1Name,
              category2Name: res.data.category2Name,
              trainingHours: res.data.trainingHours,
              skills: res.data.skills,
              skillId: res.data.skillId,
              vendorName: res.data.vendorName,
              courseDiscription: res.data.courseDiscription,
              trainingDiscription: res.data.trainingDiscription,
              comments: res.data.trainingDiscription,
              employeeCode: res.data.employeeCode,
              activeStatus: res.data.courseStatus,
              // employeeName: res.data.employeeName,
              startDateView: res.data.startDate
                ? moment(res.data.startDate).format("DD-MMM-YYYY")
                : "",
              endDateView: res.data.endDate
                ? moment(res.data.endDate).format("DD-MMM-YYYY")
                : "",
              startDate: res.data.startDate
                ? moment(res.data.startDate).format("DD-MMM-YYYY")
                : "",
              endDate: res.data.endDate
                ? moment(res.data.endDate).format("DD-MMM-YYYY")
                : "",
              additionalDates: additionalDates || [],
              // additionalDates: res.data.selectedDates ? res.data.selectedDates.map(date => moment(date).format("DD-MMM-YYYY")) : [],
              additionalDateView: additionalDates || [null],
              // additionalDateView: res.data.selectedDates ? res.data.selectedDates.map(date => moment(date).format("DD-MMM-YYYY")) : [],
              additionalErrors: additionalDates
                ? new Array(additionalDates.length).fill("")
                : [""],
              isActive: res.data?.isActive,
              isNonConsecutiveDates: res.data?.isNonConsecutiveDates,
              isNonConsecutiveDatesView: res.data?.isNonConsecutiveDates,
              isActiveTraining: res.data?.isActive,
              isRequestLoader: false,
              isRequestFailed: false,
              selectEmployee: null,
              employeeCode: res.data.employeeCode,
              totalVacancy: res.data.totalVacancy,
              vacancy: res.data.totalVacancy,
              remainingVacancy: res.data.remainingVacancy,
            },
            () => {
              if (item.isEnrolled == "Enrolled") {
                this.state.apply_for = "Apply for others";
                if (UserRole.ADMIN === this.state.currentUser) {
                  let myOffcanvas = new window.bootstrap.Offcanvas(
                    document.getElementById("AddScreen"),
                  );
                  myOffcanvas.show();
                } else {
                  let myOffcanvas = new window.bootstrap.Offcanvas(
                    document.getElementById("propertiesScreen"),
                  );
                  myOffcanvas.show();
                }
              } else {
                this.state.apply_for = "Apply for me";
                if (UserRole.ADMIN === this.state.currentUser) {
                  let myOffcanvas = new window.bootstrap.Offcanvas(
                    document.getElementById("AddScreen"),
                  );
                  myOffcanvas.show();
                } else {
                  let myOffcanvas = new window.bootstrap.Offcanvas(
                    document.getElementById("propertiesScreen"),
                  );
                  myOffcanvas.show();
                }
              }
              $("body").addClass("scrollhide");
            },
          );
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  Applyforadmin = () => {
    // if(this.state.status === "Enrolled"){
    //     this.state.apply_for = "Apply for others"
    // }
    // else{
    //     this.state.apply_for = "Apply for me"
    // }
    let valid = true;
    if (
      this.state.remainingVacancy === null ||
      this.state.remainingVacancy === undefined ||
      this.state.remainingVacancy === 0
    ) {
      toast.error("There is no vacancy for this training", {
        position: toast.POSITION.TOP_RIGHT,
        color: "#fff",
      });
      valid = false;
    }

    if (this.state.editScreen && !this.state.isActiveTraining) {
      toast.error(
        "Not able to apply for this training. This training course is Inactive.",
        {
          position: toast.POSITION.TOP_RIGHT,
          color: "#fff",
        },
      );
      valid = false;
    }

    if (
      this.state.editScreen &&
      this.state.activeStatus.toLowerCase() === "inactive"
    ) {
      toast.error(
        "Not able to apply for this training. This training course is Inactive.",
        {
          position: toast.POSITION.TOP_RIGHT,
          color: "#fff",
        },
      );
      valid = false;
    }
    if (valid) {
      $("#scrollPropertiesScreen").scrollTop(0);
      let myOffcanvas = new window.bootstrap.Offcanvas(
        document.getElementById("propertiesScreen"),
      );
      myOffcanvas.show();
      $("body").addClass("scrollhide");
    }
  };

  AddCourse = () => {
    this.setState({ isupdate: false });
    // console.log(this.state.vacancy);
    this.reset();
    this.setState({ selectCourse: null, editScreen: false });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("AddScreen"),
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  removeupcomingTraining = () => {
    this.setState({ isRequestLoader: true });
    let url = `${API.IS_TRAINING_ACTIVE}?trainingId=${this.state.id}`;
    axios({
      method: "GET",
      url: url,
    })
      .then((res) => {
        if (res.data === false) {
          this.setState({ apply_for: "", isRequestLoader: true });
          let apiUrl = `${API.REMOVE_TRAININING_DETAILS}?userId=${this.state.userId}`;
          let data = [this.state.id];
          axios({
            method: "DELETE",
            url: apiUrl,
            data: data,
          })
            .then((res) => {
              if (res.status === 200) {
                this.setState({ isRequestLoader: false, editScreen: false });
                this.GetUpcomingTrainingList();
                this.closeAddScreen();
                toast.success("Training removed successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  color: "#fff",
                });
              }
            })
            .catch((error) => {
              this.setState({ isRequestLoader: false, editScreen: false });
              logoutFunction(error?.response?.status);
              console.log(error);
              swal(
                "Error!",
                "Something went wrong. Please try again.",
                "warning",
              );
            });
        } else {
          this.setState({
            isRequestLoader: false,
          });
          toast.error(
            "Not able to remove this training. There is an applied training records for this training.",
            {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            },
          );
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  onValueChange = (event) => {
    this.setState({ apply_for: event.target.value });
  };

  handleRequest = () => {
    // this.setState({ apply_for: "", editScreen: false });
    this.setState({ isRemovePopUp: true });
    let cancelPopup = new window.bootstrap.Modal(
      document.getElementById("CancelCourseScreen"),
    );
    cancelPopup.show();
    $("body").addClass("scrollhide");
  };

  renderCourseCode(state, val) {
    return state?.courseCode?.toLowerCase()?.indexOf(val?.toLowerCase()) !== -1;
  }

  renderEmployeeName(state, val) {
    return (
      state?.employeeName?.toLowerCase()?.indexOf(val?.toLowerCase()) !== -1
    );
  }

  reset = () => {
    this.setState({
      id: 0,
      courseId: 0,
      courseCode: "",
      courseTitle: "",
      startDate: "",
      endDate: "",
      comments: "",
      editScreen: false,
      coursecodeEmpty: false,
      startDateEmpty: false,
      endDateEmpty: false,
      vacancy: 0,
      vacancyEmpty: false,
      additionalDates: [null],
      additionalErrors: [],
      additionalDatesDuplicate: false,
      isActive: true,
      isNonConsecutiveDates: false,
      isNonConsecutiveDatesView: false,
    });
  };

  applyreset = () => {
    this.setState(
      {
        skills: "",
        category1Name: "",
        category2Name: "",
        trainingHours: "",
        courseDiscription: "",
        trainingDiscription: "",
        employeeId: "",
        employeeName: "",
        employeeCode: "",
        applyComments: "",
        employeeEmpty: false,
        apply_for: "Apply for me",
        searchInputData: {
          trainingRequestId: "",
          skills: "",
          skillId: 0,
          vendorName: "",
          courseCode: "",
          courseTitle: "",
          startDate: null,
          endDate: null,
          status: "",
          activeStatus: "",
          trainingStatus: "",
        },
        isSearch: false,
        employeeNameList: [],
      },
      () => {
        this.GetUpcomingTrainingList();
      },
    );
  };

  closeApplyTraining = () => {
    this.state.applyComments = "";
    $("#AddScreen").removeClass("show");
    $("#propertiesScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    this.setState({ selectedOption: null, apply_for: "" });
  };

  backtoApplyTraining = () => {
    // this.state.applyComments = "";
    // $("#AddScreen").removeClass("show");
    $("#propertiesScreen").removeClass("show");
    this.setState({ selectedOption: null });
    // $("body").removeClass("scrollhide")
  };

  closeAddScreen = () => {
    // $("#AddScreen").removeClass("show");
    $("#propertiesScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    this.reset();
    document.getElementById("closeSearchScreen").click();
  };

  onchangeCourseCode = (e) => {
    if (e === null) {
      this.state.courseId = "";
      this.state.courseCode = "";
      this.state.courseTitle = "";
      this.state.selectCourse = [];
      this.setState({});
    } else {
      this.state.courseId = parseInt(e.value.split(",")[0]);
      this.state.courseCode = e.value.split(",")[1];
      this.state.courseTitle = e.value.split(",")[2];
      this.state.selectCourse = e;
      this.setState({});
    }
  };

  //   handleEmployeeChange(value, field, id, fieldId, employeeCode, fieldName) {
  //     this.setState({ [field]: value, [fieldId]: id, [fieldName]: employeeCode, employeeEmpty: false });
  // }

  handleEmployeeChange = (e) => {
    if (e === null) {
      this.state.employeeId = "";
      this.state.employeeCode = "";
      this.state.employeeName = "";
      this.state.selectEmployee = [];
      this.setState({}, () => {
        let myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById("propertiesScreen"),
        );
        myOffcanvas.show();
      });
    } else {
      this.state.employeeId = parseInt(e.value.split(",")[0]);
      this.state.employeeCode = e.value.split(",")[1];
      this.state.employeeName = e.value.split(",")[2];
      this.state.selectEmployee = e;
      this.setState({}, () => {
        let myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById("propertiesScreen"),
        );
        myOffcanvas.show();
      });
    }
  };

  handleBlur = () => {
    setTimeout(() => {
      if (this.state.courseCode !== "" && this.state.courseId === 0) {
        this.setState((prevData) => ({
          ...prevData,
          courseCode: "",
        }));
      }
    }, 500);
  };

  handleInputchange(e, field) {
    if (field === "startDate" || field === "endDate") {
      let dates = new Date(e);
      this.state.searchInputData[field] = dates;
    } else {
      this.state.searchInputData[field] = e.target.value;
    }
    this.setState({});
  }

  getEmployeeName = async () => {
    // this.setState({ isRequestLoader: true, isRequestFailed: false });
    let apiUrl = `${API.GET_EMPLOYEES}?userId=${this.state.userId}`;
    let res = await this.updateGetFunction(apiUrl);
    if (res.status === 200) {
      this.state.employeeNameList = res?.data?.map((employee) => {
        return {
          value: employee.employeeName,
          label: (
            <>
              <span>{employee.employeeName}</span>
            </>
          ),
        };
      });
      // this.setState({
      //     isRequestLoader: false,
      //     isRequestFailed: false
      // })
    }
  };

  updateGetFunction = async (uri) => {
    try {
      const response = await axios({
        method: "GET",
        url: uri,
      });

      let responseData = {
        ok: true,
        status: 200,
        statusText: "success",
        data: response.data,
        error: undefined,
        type: "retrieve",
        url: uri,
      };

      return responseData;
    } catch (error) {
      logoutFunction(error?.response?.status);
      let responseData = {
        ok: false,
        status: error.response?.status || 500,
        statusText: error.response?.statusText || "Internal Server Error",
        error: error.response?.data?.message || "Unknown Error",
        type: "retrieve",
        url: uri,
      };
      swal("Error!", "Something went wrong. Please try again.", "warning");
      this.setState({ isRequestLoader: false });
      return responseData;
    }
  };

  onchangeEmployeeName = (e, field) => {
    if (e === null) {
      this.state.searchInputData[field] = "";
      this.state.selectEmployeeName = [];
      this.setState({});
    } else {
      this.state.searchInputData[field] = e.label;
      this.state.selectEmployeeName = e;
      this.setState({});
    }
  };
  onchangeVendorName = (e, field) => {
    if (e === null) {
      this.state.searchInputData[field] = "";
      this.state.selectVendorName = [];
      this.setState({});
    } else {
      this.state.searchInputData[field] = e.label;
      this.state.selectVendorName = e;
      this.setState({});
    }
  };
  onchangeSkillName = (e, field) => {
    if (e === null) {
      this.state.searchInputData[field] = "";
      this.state.selectSkillsName = [];
      this.setState({});
    } else {
      this.state.searchInputData[field] = e.label;
      this.state.selectSkillsName = e;
      this.setState({});
    }
  };

  onChangeCourseStatus = (e) => {
    this.state.searchInputData.activeStatus = e.target.value;
    this.setState({});
  };

  validateSearchRecords = () => {
    const inputs = document.querySelectorAll(
      ".records-editinput-class[required]",
    );
    const isValid = Array?.from(inputs)?.some((input) => input.value !== "");
    const isValid1 =
      this.state.searchInputData.startDate ||
      this.state.searchInputData.endDate;
    const isValid2 =
      (this.state.selectSkillsName &&
        this.state.selectSkillsName?.length !== 0) ||
      (this.state.selectVendorName &&
        this.state.selectVendorName?.length !== 0) ||
      this.state.searchInputData?.activeStatus?.trim()?.length > 0;
    if (isValid || isValid1 || isValid2) {
      this.submitSearchDetails();
      this.setState({
        validationMsg: false,
      });
    } else {
      this.setState({
        validationMsg: true,
      });
    }
  };

  submitSearchDetails = () => {
    this.state.isSearch = true;
    this.state.currentPage = 1;
    this.state.pageNewCount = !this.state.pageNewCount;
    this.setState({}, () => this.GetUpcomingTrainingList());
    $("#propertiesScreen").removeClass("show");
    $("#AddScreen").removeClass("show");
    $("#searchScreen").addClass("display-hide");
    $("#searchScreen").removeClass("visible-show");
    $("body").removeClass("scrollhide");
  };

  openSearch = () => {
    // let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("searchScreen"));
    // myOffcanvas.show();
    $("#searchScreen").removeClass("display-hide");
    $("#searchScreen").addClass("visible-show");
    $("body").addClass("scrollhide");
    // this.state.isRequestLoader = true;
  };

  clearSearchDetails = () => {
    this.reset();
    this.setState({
      isSearch: false,
      selectSkillsName: null,
      selectVendorName: null,
      pageNewCount: !this.state.pageNewCount,
      currentPage: 1,
      validationMsg: false,
    });
    this.applyreset();
    // this.GetUpcomingTrainingList();
    $("#propertiesScreen").removeClass("show");
    $("#AddScreen").removeClass("show");
    $("#searchScreen").addClass("display-hide");
    $("#searchScreen").removeClass("visible-show");
    $("body").removeClass("scrollhide");
  };

  closeWithoutClearData = () => {
    $("#propertiesScreen").removeClass("show");
    $("#AddScreen").removeClass("show");
    $("#searchScreen").addClass("display-hide");
    $("#searchScreen").removeClass("visible-show");
    $("body").removeClass("scrollhide");
  };

  isCourseAdded = () => {
    this.setState({
      isRequestLoader: true,
    });
    if (
      this.state.editScreen &&
      this.state.activeStatus?.toLowerCase() === "inactive"
    ) {
      this.setState({
        isRequestLoader: false,
      });
      toast.error(
        "Not able to update this training. This training course is Inactive.",
        {
          position: toast.POSITION.TOP_RIGHT,
          color: "#fff",
        },
      );
    } else {
      let existUrl = `${API.IS_COURSE_ADD}?courseId=${this.state.courseId}`;
      axios.get(existUrl).then((response) => {
        if (response.data?.length === 0) {
          this.saveUpcomingTraining();
        } else {
          let isvalid = this.validation();
          if (isvalid) {
            let pte, lou, cq;

            if (response.data?.includes("lou")) {
              lou = "LOU";
            }
            if (response.data?.includes("pte")) {
              pte = "PTE";
            }
            if (response.data?.includes("coursequestionaire")) {
              cq = "Course Questionnaire";
            }
            this.setState({ isRequestLoader: false });
            const missingCourses = [lou, pte, cq].filter(Boolean).join(", ");
            const toastMessage = `${missingCourses} is not submitted for this course please submit ${missingCourses} to add training`;
            toast.error(toastMessage, {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
          } else {
            this.setState({ isRequestLoader: false });
          }
          // ["lou","pte","coursequestionaire"]
          // let pte,lou,cq;
          // if(response.data?.find((item) => item === "lou")){
          //     lou = "LOU";
          // }
          // else if(response.data?.find((item) => item === "pte")){
          //     pte = "PTE";
          // }
          // else if(response.data?.find((item) => item === "coursequestionaire")){
          //     cq = "coursequestionaire";
          // }
          // else{}
          // toast.error(
          //     // "This Course is already given. Please add another Course.",
          //     `The training does'nt have ${lou} , ${pte} and ${cq}`,
          //     // response,
          //     {
          //         position: toast.POSITION.TOP_RIGHT,
          //         color: "#fff",
          //     }
          // );
        }
      });
    }
  };

  applyFormeToast = () => {
    toast.error("This training is already applied for this user", {
      position: toast.POSITION.TOP_RIGHT,
      color: "#fff",
    });
  };

  handleSelectedChange = (selectedOption) => {
    if (selectedOption) {
      this.setState({ selectedOption: selectedOption }, () => {
        const empId = this.state.selectedOption?.map(
          (e) => e.value.split(",")[0] * 1,
        );
        this.setState({ selectedEmployeeId: empId });
        const empname = this.state.selectedOption?.map(
          (e) => e.value.split(",")[2],
        );
        this.setState({ selectedEmployeeName: empname });
      });
      let myOffcanvas = new window.bootstrap.Offcanvas(
        document.getElementById("propertiesScreen"),
      );
      myOffcanvas.show();
      $("body").addClass("scrollhide");
    }
  };

  addDays = (date, days) => {
    if (!date) return null;
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  render() {
    const {
      isMobile,
      isRadioMobile,
      isRequestFailed,
      isRequestLoader,
      isSmallMobile,
      iswebMobile,
      upcomingList,
      pageCount,
      isSortAscending,
      currentUser,
      sortBy,
      apply_for,
      selectedOption,
    } = this.state;
    let { menuToggle } = this.props;
    return (
      <>
        <Toaster />
        {$("#propertiesScreen").hasClass("show") ||
        $("#AddScreen").hasClass("show") ||
        $("#searchScreen").hasClass("visible-show") ? (
          <div className="viewbar-overlay"></div>
        ) : (
          <></>
        )}
        <div
          className={`${
            isMobile
              ? "company-main-body-mobile"
              : menuToggle
                ? "menu-main-body"
                : "main-body"
          } `}
        >
          <LoaderVisible isLoader={isRequestLoader} />
          <LoaderVisible isLoader={isRequestFailed} />

          <div className="head-fixed-company">
            {isMobile == true ? (
              // <div className="mobile-head border-bottom w-100">
              //         <div className="col-12 mobile-title"> Company training calendar</div>
              // </div>
              <div className={`p-0 mr-0 w-80 `}>
                <span
                  className={`mobile-head border-bottom w-100 d-flex justify-content-between`}
                >
                  <span className="mobile-title">
                    Company training calendar
                  </span>
                  {/* <span onClick={() => this.openSearch()}><CommonIcon fileName="searchIcon1" /></span> */}
                  {UserRole.ADMIN !== currentUser && (
                    <span onClick={() => this.openSearch()}>
                      <CommonIcon fileName="searchIcon1" />
                    </span>
                  )}
                </span>
              </div>
            ) : (
              // <div className="title">
              // <CommonIcon fileName="courseMasterActive"/><span className="pl-10 head-span ">Company training calendar</span>
              // </div>
              // <div className="title buttonFullWidth row pr-0 align-items-center">
              //     <div className={`col-10 p-0 mr-0  ${menuToggle ? "w-80" : "w-60"}`}>
              //         <span className=""><CommonIcon fileName="Companyhead" /></span>
              //         <span className="pl-10 head-span ">
              //             Company training calendar
              //         </span>
              //     </div>
              //     {
              //         UserRole.ADMIN !== currentUser &&
              //         <div className={`col-2 text-end  ${menuToggle ? "w-20" : "w-24"}`}>
              //             <button className={`displaybutton ${isRadioMobile ? "pr-0" : ""} ${isSmallMobile ? "pl-0" : ""}`} id="displaybuttoncolor" onClick={() => this.openSearch()}>
              //                 <CommonIcon fileName="searchIcon1" />
              //             </button>
              //         </div>
              //     }
              // </div>
              <div
                className={` ${
                  menuToggle ? "width-100" : "width-filter"
                } px-4 position-relative border-bottom row `}
              >
                <div className="col-6 border-none title">
                  <span className="mt-3px">
                    <CommonIcon fileName="Companyhead" />
                  </span>
                  <span className="pl-10 head-span">
                    Company training calendar
                  </span>
                </div>
                {/* <div className="filter-icon cursor-pointer text-align-end" onClick={this.openSearchFilter}>
                     <CommonIcon fileName="filterIcon" />
                  </div> */}
                {UserRole.ADMIN !== currentUser && (
                  <div className="text-align-end  title border-none display text-16-red mt-3px col-6">
                    <span
                      className="text-20-bold pr-30 cursor-pointer"
                      onClick={() => this.openSearch()}
                    >
                      <CommonIcon fileName="filterIcon" />
                    </span>
                  </div>
                )}
              </div>
            )}
            {UserRole.ADMIN === currentUser && (
              <div
                className={`${
                  isMobile ? "" : "pl-10"
                } position-relative border-bottom`}
              >
                <div
                  className={`col-12 d-flex justify-content-start  ${
                    isMobile ? "pr-0 pl-17" : "p-1 pl-10"
                  } ${menuToggle ? "width-100" : "width-filter"}`}
                >
                  <button
                    className={`displaybutton ${isRadioMobile ? "pr-5" : ""} ${
                      isSmallMobile ? "pl-5" : ""
                    }`}
                    onClick={() => this.AddCourse()}
                  >
                    <CommonIcon fileName="addIcon" />
                    <span className={`subhead-span p-2`}>Add</span>
                  </button>
                  <div
                    className={`position-absolute  end-0 ${
                      isMobile ? "" : menuToggle ? "ml-role-updated" : "ml-role"
                    }`}
                  >
                    <button className="displaybutton" onClick={this.openSearch}>
                      <span>
                        <CommonIcon fileName="filterIcon" />
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* <ToastContainer /> */}
          {}
          <div
            className={`${
              isMobile
                ? UserRole.ADMIN === currentUser
                  ? "Upcoming-table-style"
                  : "Upcoming-mobile-notAdmin"
                : UserRole.ADMIN === currentUser
                  ? "upcoming-table-mobile"
                  : "Upcoming-notAdmin"
            } table-responsive w-100`}
          >
            <div
              className={`table-fixed-header ${
                UserRole.ADMIN === currentUser
                  ? isMobile
                    ? "table-scroll-xy-mobile top-upcoming-training-mobile"
                    : menuToggle
                      ? "table-scroll-xy-menutoggle top-upcoming-training"
                      : "table-scroll-xy top-upcoming-training"
                  : isMobile
                    ? "table-scroll-xy-mobile top-upcoming-training-calendar-mobile"
                    : menuToggle
                      ? "table-scroll-xy-menutoggle"
                      : "table-scroll-xy"
              } table-list-view-bottom`}
            >
              <table
                className={`table fileListTable2 table-borderless table-hover`}
              >
                <thead>
                  <tr>
                    <td></td>
                    <td
                      className="cursor-pointer"
                      onClick={() =>
                        this.sortTable("courseCode", isSortAscending)
                      }
                    >
                      <span>Course code </span>
                      {sortBy === "courseCode" && (
                        <CommonIcon
                          fileName={isSortAscending ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() =>
                        this.sortTable("courseTitle", isSortAscending)
                      }
                    >
                      <span>Course title </span>
                      {sortBy === "courseTitle" && (
                        <CommonIcon
                          fileName={isSortAscending ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() =>
                        this.sortTable("vendorName", isSortAscending)
                      }
                    >
                      <span>Vendor </span>
                      {sortBy === "vendorName" && (
                        <CommonIcon
                          fileName={isSortAscending ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("status", isSortAscending)}
                    >
                      <span>Status </span>
                      {sortBy === "status" && (
                        <CommonIcon
                          fileName={isSortAscending ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    {UserRole.ADMIN === currentUser && (
                      <td
                        className="cursor-pointer"
                        onClick={() =>
                          this.sortTable("trainingStatus", isSortAscending)
                        }
                      >
                        <span>Training status </span>
                        {sortBy === "trainingStatus" && (
                          <CommonIcon
                            fileName={isSortAscending ? "upArrow" : "downArrow"}
                          />
                        )}
                      </td>
                    )}
                    {UserRole.ADMIN === currentUser && (
                      <td
                        className="cursor-pointer"
                        onClick={() =>
                          this.sortTable("skills", isSortAscending)
                        }
                      >
                        <span>Skills </span>
                        {sortBy === "skills" && (
                          <CommonIcon
                            fileName={isSortAscending ? "upArrow" : "downArrow"}
                          />
                        )}
                      </td>
                    )}
                    <td
                      className="cursor-pointer"
                      onClick={() =>
                        this.sortTable("trainingHours", isSortAscending)
                      }
                    >
                      <span>Training hours </span>
                      {sortBy === "trainingHours" && (
                        <CommonIcon
                          fileName={isSortAscending ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer text-nowrap"
                      onClick={() =>
                        this.sortTable("remainingVacancy", isSortAscending)
                      }
                    >
                      <span>Available vacancies</span>
                      {sortBy === "remainingVacancy" && (
                        <CommonIcon
                          fileName={isSortAscending ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() =>
                        this.sortTable("startDate", isSortAscending)
                      }
                    >
                      <span>Start date </span>
                      {sortBy === "startDate" && (
                        <CommonIcon
                          fileName={isSortAscending ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("endDate", isSortAscending)}
                    >
                      <span>End date</span>
                      {sortBy === "endDate" && (
                        <CommonIcon
                          fileName={isSortAscending ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    {this.state.currentUser === UserRole.ADMIN && (
                      <td
                        className="cursor-pointer"
                        onClick={() =>
                          this.sortTable("courseStatus", isSortAscending)
                        }
                      >
                        <span>Course status</span>
                        {sortBy === "courseStatus" && (
                          <CommonIcon
                            fileName={isSortAscending ? "upArrow" : "downArrow"}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {upcomingList.length !== 0 ? (
                    upcomingList.map((item, index) => (
                      <tr
                        id={"active" + item.id}
                        key={index}
                        className="requestRadioSelect"
                      >
                        <td></td>
                        <td
                          className="width-150px"
                          onClick={() => this.UpcomingDetails(item)}
                        >
                          <span className="cursor-pointer">
                            <a className="link">{item.courseCode}</a>
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>{item.courseTitle}</span>
                        </td>
                        <td className="width-150px">
                          <span>{item.vendorName}</span>
                        </td>
                        <td className="width-150px">
                          <span>{item.status}</span>
                        </td>
                        {UserRole.ADMIN === currentUser && (
                          <td className="width-150px">
                            <span>{item.trainingStatus || "-"}</span>
                          </td>
                        )}
                        {UserRole.ADMIN === currentUser && (
                          <td className="width-150px">
                            <span>{item.skills}</span>{" "}
                          </td>
                        )}
                        <td className="width-150px">
                          <span>{item.trainingHours}</span>
                        </td>
                        <td className="text-nowrap">
                          <span>{item.remainingVacancy}</span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.startDate
                              ? moment(
                                  new Date(Date.parse(item.startDate)),
                                ).format("DD-MMM-YYYY")
                              : ""}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.endDate
                              ? moment(
                                  new Date(Date.parse(item.endDate)),
                                ).format("DD-MMM-YYYY")
                              : ""}
                          </span>
                        </td>
                        {this.state.currentUser === UserRole.ADMIN && (
                          <td className="width-150px">
                            <span>{item.courseStatus}</span>
                          </td>
                        )}
                        {/* <td></td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={10} className="table-nodata text-center">
                        {"No record found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div
            className={`${
              isMobile
                ? "common-mobilesubmenu mobile-pagination"
                : menuToggle
                  ? "common-submenu sidemenu-pagination"
                  : "common-submenu web-pagination"
            } pb-2 pt-2`}
          ></div>
        </div>

        {/* Add New Course */}
        <div
          className="offcanvas offcanvas-end offcanvasStyle"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="AddScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          {/* heading */}
          <div
            className={`offcanvas-header px-4 pt-4 ${
              isMobile ? "pb-2" : "pb-3 mt-10"
            }`}
          >
            <h6
              id="offcanvasRightLabel"
              className="modal-title pr-10 head-span fw-600"
            >
              {this.state.editScreen
                ? this.state.courseCodeHeader
                : "Add trainings"}
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle cross-icon-fixed-1 background-white ${
                isMobile ? "pr-0" : ""
              }`}
              onClick={() => this.closeAddScreen()}
            >
              <CommonIcon
                fileName="CrossIcon"
                className="cursor-pointer app-image-hover"
              />
            </button>
            <button
              data-bs-dismiss="offcanvas"
              className="d-none"
              id="closeSearchScreen"
            ></button>
          </div>

          <div className="offcanvas-body px-4 pt-0">
            <div className="row">
              {/* input box */}
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-2"
                }`}
              >
                <div>
                  <label
                    className={`label-text ${
                      isMobile
                        ? "d-flex pt-2 mb-2-ledger"
                        : "d-flex mb-2-ledger"
                    }`}
                  >
                    <CommonIcon
                      className="properties-img-2"
                      fileName="CourseCodeIcon"
                    />{" "}
                    <span className="pl-10 properties-search-span">Course</span>
                    <span className="MuiFormHelperText-contained">*</span>
                  </label>
                  {this.state.editScreen ? (
                    <>
                      <input
                        type="text"
                        className="form-control form-text-box-select color-grey"
                        value={this.state.selectCourse.value}
                        readOnly
                      />
                    </>
                  ) : (
                    <>
                      <Select
                        className={`text-12-normal-select my-input-class  ${
                          this.state.coursecodeEmpty && "border-red"
                        }  `}
                        classNamePrefix="assigngroups"
                        placeholder="Please select an option"
                        styles={styles}
                        value={this.state.selectCourse}
                        options={this.state.courseCodeList}
                        defaultValue={this.state.selectCourse || "Select"}
                        isClearable={true}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        isMulti={false}
                        isSearchable={true}
                        // isDisabled={ this.state.editScreen && true}
                        // readOnly={true}
                        onChange={this.onchangeCourseCode}
                      />
                    </>
                  )}
                  {this.state.coursecodeEmpty === true ? (
                    <span className="send-rework-label">
                      This field is required
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              {/* <div
                                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-2"}`}>
                                <div className="form-group">
                                    <label
                                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon className="properties-img-2" fileName="CourseTitleIcon" />{" "}
                                        <span className="pl-5 properties-span ">Course title</span><span className="MuiFormHelperText-contained">*</span>
                                        <label className="required"></label>
                                    </label>
                                    <label className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
                                        {this.state.courseTitle}
                                    </label>
                                </div>
                            </div> */}
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-2"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon
                      className="properties-img-2"
                      fileName="UserIcon"
                    />{" "}
                    <span className="pl-5 properties-span">Vacancies</span>
                    <span className="MuiFormHelperText-contained">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control pb-1 rounded-0 ${
                      this.state.vacancyEmpty && "border border-danger"
                    }`}
                    value={this.state.vacancy}
                    placeholder="No.of Vacancies"
                    onChange={(e) => this.handleVacancyChange(e)}
                  />
                  {this.state.vacancyEmpty === true ? (
                    <span className="send-rework-label">
                      This field is required
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div className={isMobile ? "col-12" : "col-12"}>
                <label
                  className={
                    isMobile
                      ? "d-flex pt-2 m-0"
                      : "d-flex m-0 text-left float-start align-items-center"
                  }
                >
                  <CommonIcon
                    className="properties-img-2"
                    fileName="DateIcon"
                  />{" "}
                  <span className="pl-5 properties-span-2">
                    Is non consecutive dates&nbsp;
                  </span>
                  &nbsp;
                </label>
              </div>

              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 d-flex`}
              >
                <div class={` ${"form-check form-switch"}`}>
                  <input
                    class={`${"form-check-input toggle-button"}`}
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckChecked"
                    onChange={(e) => {
                      this.handleChange(
                        {
                          target: {
                            value: e.target.checked,
                            name: "isNonConsecutiveDates",
                          },
                        },
                        "text",
                        "isActive",
                      );
                    }}
                    checked={this.state.isNonConsecutiveDates}
                  />
                </div>
                {/* <label class={`mt-1 pl-10 view-text`}>
                  {this.state.isNonConsecutiveDates == true ? "Active" : "Inactive"}
                </label> */}
              </div>
              {!this.state.isNonConsecutiveDates && (
                <>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-2"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="DateIcon"
                        />{" "}
                        <span className="pl-5 properties-span">Start date</span>
                        <span className="MuiFormHelperText-contained">*</span>
                      </label>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          className="form-control f-12 mt-1"
                          emptyLabel="dd-mmm-yyyy"
                          keyboardIcon={
                            <CommonIcon
                              className="properties-img-2"
                              fileName="calenderDate"
                            />
                          }
                          format="dd-MMM-yyyy"
                          value={
                            this.state.startDate ? this.state.startDate : null
                          }
                          size="small"
                          onChange={(e) =>
                            this.handleDateChange(e, "startDate")
                          }
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </MuiPickersUtilsProvider>

                      {this.state.startDateEmpty === true ? (
                        <span className="send-rework-label">
                          This field is required
                        </span>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-2"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="DateIcon"
                        />{" "}
                        <span className="pl-5 properties-span">End date</span>
                        <span className="MuiFormHelperText-contained">*</span>
                      </label>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          autoOk
                          minDate={this.state.startDate}
                          variant="inline"
                          inputVariant="outlined"
                          className="form-control f-12 mt-1"
                          emptyLabel="dd-mmm-yyyy"
                          keyboardIcon={
                            <CommonIcon
                              className="properties-img-2"
                              fileName="calenderDate"
                            />
                          }
                          format="dd-MMM-yyyy"
                          value={this.state.endDate ? this.state.endDate : null}
                          size="small"
                          onChange={(e) => this.handleDateChange(e, "endDate")}
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </MuiPickersUtilsProvider>
                      {this.state.endDateEmpty === true ? (
                        <span className="send-rework-label">
                          This field is required
                        </span>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </>
              )}
              {this.state.isNonConsecutiveDates && (
                <>
                  {this.state.additionalDates.length > 0 && (
                    <div className="col-12 mt-3 mt-lg-2 ">
                      <label
                        className={`d-flex m-0 align-items-center label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="DateIcon"
                        />{" "}
                        <span className="pl-5 properties-span">
                          Training dates
                        </span>
                        <span className="MuiFormHelperText-contained">*</span>
                      </label>
                    </div>
                  )}
                  {this.state.additionalDates.map((date, index) => (
                    <div
                      key={index}
                      className="col-12 mt-3 mt-lg-2 mb-2 mt-mb-3"
                    >
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "4px" }}
                      >
                        <div className="flex-grow-1 form-group">
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              autoOk
                              variant="inline"
                              minDateMessage=""
                              maxDateMessage=""
                              invalidDateMessage=""
                              inputVariant="outlined"
                              className="form-control f-12 mt-1"
                              emptyLabel="dd-mmm-yyyy"
                              keyboardIcon={
                                <CommonIcon
                                  className="properties-img-2"
                                  fileName="calenderDate"
                                />
                              }
                              format="dd-MMM-yyyy"
                              value={date}
                              size="small"
                              // minDate={this.addDays(this.state.startDate, 1)}
                              // maxDate={this.addDays(this.state.endDate, -1)}
                              onChange={(e) =>
                                this.handleAdditionalDateChange(e, index)
                              }
                              inputProps={{
                                readOnly: true,
                              }}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                        {this.state.additionalDates.length > 1 && (
                          <div
                            className=" d-flex align-items-center justify-content-center"
                            onClick={() => this.removeDate(index)}
                          >
                            <CommonIcon fileName="CrossIcon" />
                          </div>
                        )}
                      </div>
                      {this.state.additionalErrors[index] && (
                        <span className="send-rework-label">
                          {this.state.additionalErrors[index]}
                        </span>
                      )}
                    </div>
                  ))}
                  <div
                    className={`col-12 d-flex  mt-2 mb-2 ${this.state.additionalDatesDuplicate ? "justify-content-between" : " justify-content-end "}`}
                  >
                    {this.state.additionalDatesDuplicate && (
                      <span className="send-rework-label">
                        No duplicate training dates allowed
                      </span>
                    )}
                    <button
                      className={`btn pte-add-button1`}
                      onClick={this.addDate}
                    >
                      <CommonIcon
                        fileName="vendoraddIcon"
                        className="modal-img"
                      />
                      <span className="model-label1 pl-5">
                        Add training date
                      </span>
                    </button>
                  </div>
                </>
              )}

              {this.state.isupdate && (
                <label className="pb-1 pt-1">
                  Available vacancies - {this.state.remainingVacancy}
                </label>
              )}
              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${
                  isMobile ? "" : "pb-2"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon
                      className="properties-img-2"
                      fileName="CommentIcon"
                    />{" "}
                    <span className="pl-5 properties-span">Comments</span>
                    <label className="required"></label>
                  </label>
                  <textarea
                    name="comments"
                    value={this.state.comments}
                    onChange={(e) => this.handleChange(e, "text")}
                    className={`text-wrap form-text-box2 resize-none border-radius-0 ${
                      isMobile
                        ? "form-control form-control-mobile"
                        : "form-control"
                    }`}
                    id="course_desc"
                    rows="3"
                  ></textarea>
                </div>
              </div>
              {this.state.editScreen && (
                <>
                  <div className={isMobile ? "col-12" : "col-12"}>
                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <CommonIcon
                        className="properties-img-2"
                        fileName="MyselfIcon"
                      />
                      <span className="pl-5 properties-span-2">
                        Training status&nbsp;
                      </span>
                      &nbsp;
                    </label>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 d-flex`}
                  >
                    <div class={` ${"form-check form-switch"}`}>
                      <input
                        class={`${"form-check-input toggle-button"}`}
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckChecked"
                        onChange={(e) => {
                          this.handleChange(
                            {
                              target: {
                                value: e.target.checked,
                                name: "isActive",
                              },
                            },
                            "text",
                            "isActive",
                          );
                        }}
                        checked={this.state.isActive}
                      />
                    </div>
                    <label
                      class={`mt-1 pl-10 view-text`}
                      // for={this.state.allowDisable == false ? "" : "flexSwitchCheckChecked"}
                    >
                      {this.state.isActive == true ? "Active" : "Inactive"}
                    </label>
                  </div>
                </>
              )}
            </div>

            <div className="row mt-1">
              {this.state.editScreen && (
                <div
                  className={`${
                    iswebMobile ? "col-12" : "col-4"
                  } col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3  ${
                    isMobile ? "mt-4" : "mt-2"
                  }`}
                >
                  <button
                    className={`btn btn-light input-group offcavasclose warning-btn p-2`}
                    onClick={() => this.handleRequest()}
                  >
                    <CommonIcon
                      fileName="ButtonRejectIcon"
                      className="modal-img"
                    />
                    <span className="send-rework-label pl-5"> Remove </span>
                  </button>
                </div>
              )}
              <div
                className={`${
                  iswebMobile ? "col-12" : "col-4"
                } col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3  ${
                  isMobile ? "mt-4" : "mt-2"
                }`}
              >
                <button
                  className={`btn btn-light input-group offcavasclose filter-nextbtn p-2`}
                  onClick={this.isCourseAdded}
                >
                  <CommonIcon
                    fileName="ButtonSubmitIcon"
                    className="modal-img"
                  />
                  <span className="model-label pl-5">
                    {this.state.editScreen ? "Update" : "Submit"}
                  </span>
                </button>
              </div>
              {this.state.editScreen && (
                <div
                  className={`${
                    iswebMobile ? "col-12" : "col-4"
                  } col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3  ${
                    isMobile ? "mt-4" : "mt-2"
                  }`}
                >
                  <button
                    className={`btn btn-light input-group offcavasclose filter-nextbtn p-2`}
                    onClick={this.Applyforadmin}
                  >
                    <CommonIcon
                      fileName="ButtonSubmitIcon"
                      className="modal-img"
                    />
                    <span className="model-label pl-5">Apply</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas offcanvas-end offcanvasStyle"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="propertiesScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${
              isMobile ? "pb-2" : "pb-3 mt-10"
            }`}
          >
            <h6
              id="offcanvasRightLabel"
              className="modal-title head-span fw-600"
            >
              {this.state.enrolledStatus === "Enrolled"
                ? "Applied training"
                : "Apply for training"}
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle background-white ${
                isMobile ? "pr-0" : ""
              }`}
              onClick={() => this.closeApplyTraining()}
            >
              <CommonIcon
                fileName="CrossIcon"
                className="cursor-pointer app-image-hover"
              />
            </button>
          </div>

          <div className="offcanvas-body px-4 pt-0" id="scrollPropertiesScreen">
            <div className="row">
              {/* input box */}
              {UserRole.EMPLOYEE != currentUser && (
                <div
                  className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${
                    isMobile ? "" : "pb-2"
                  }`}
                >
                  <div className="form-group">
                    {this.state.enrolledStatus === "Enrolled" ? (
                      <>
                        <input
                          className="height"
                          type="radio"
                          name="applyfor"
                          value="Apply for me"
                          disabled
                        />
                        <div
                          className="radio-button-disabled"
                          onClick={this.applyFormeToast}
                        ></div>
                        <label className={`${isMobile ? "pl-3" : "pl-10"}`}>
                          Apply for me
                        </label>
                        <input
                          className="height ml-10"
                          type="radio"
                          name="applyfor"
                          value="Apply for others"
                          checked
                          onChange={this.onValueChange}
                        />{" "}
                        <label className={`${isMobile ? "pl-3" : "pl-10"}`}>
                          Apply for others
                        </label>
                      </>
                    ) : (
                      <>
                        <input
                          className="height"
                          type="radio"
                          name="applyfor"
                          value="Apply for me"
                          checked={apply_for === "Apply for me"}
                          onChange={this.onValueChange}
                        />{" "}
                        <label className={`${isMobile ? "pl-3" : "pl-10"}`}>
                          Apply for me
                        </label>
                        <input
                          className="height ml-10"
                          type="radio"
                          name="applyfor"
                          value="Apply for others"
                          checked={apply_for === "Apply for others"}
                          onChange={this.onValueChange}
                        />{" "}
                        <label className={`${isMobile ? "pl-3" : "pl-10"}`}>
                          Apply for others
                        </label>
                      </>
                    )}
                  </div>
                </div>
              )}
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-2"
                }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon
                      className="properties-img-2"
                      fileName="CourseCodeIcon"
                    />{" "}
                    <span className="pl-5 properties-span">Course code</span>
                  </label>
                  <label
                    className={`properties-label ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  >
                    {this.state.courseCode}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-2"
                }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon
                      className="properties-img-2"
                      fileName="CourseTitleIcon"
                    />{" "}
                    <span className="pl-5 properties-span ">Course title</span>
                  </label>
                  <label
                    className={`properties-label ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  >
                    {this.state.courseTitle}
                  </label>
                </div>
              </div>

              <div
                className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-2"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon
                      className="properties-img-2"
                      fileName="VendorNameIcon"
                    />{" "}
                    <span className="pl-7 properties-span">Vendor</span>
                  </label>
                  <label
                    className={`properties-label ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  >
                    {this.state.vendorName}
                  </label>
                </div>
              </div>
              {UserRole.EMPLOYEE != currentUser && (
                <>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-2"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="skillIcon"
                        />{" "}
                        <span className="pl-7 properties-span">Skill</span>
                      </label>
                      <label
                        className={`properties-label ${
                          isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      >
                        {this.state.skills}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-2"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="courseCategoryIcon"
                        />{" "}
                        <span className="pl-7 properties-span">Category 1</span>
                      </label>
                      <label
                        className={`properties-label ${
                          isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      >
                        {this.state.category1Name}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-2"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="courseCategoryIcon"
                        />{" "}
                        <span className="pl-7 properties-span">Category 2</span>
                      </label>
                      <label
                        className={`properties-label ${
                          isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      >
                        {this.state.category2Name}
                      </label>
                    </div>
                  </div>
                </>
              )}

              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-2"
                }`}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon
                      className="properties-img-2"
                      fileName="hoursIcon"
                    />{" "}
                    <span className="pl-5 properties-span ">
                      Training hours
                    </span>
                  </label>
                  <label
                    className={`properties-label ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  >
                    {this.state.trainingHours}
                  </label>
                </div>
              </div>
              {!this.state.isNonConsecutiveDatesView && (
                <>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-2"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="DateIcon"
                        />{" "}
                        <span className="pl-10 properties-span">
                          Start date
                        </span>
                      </label>
                      <label
                        className={`properties-label ${
                          isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                      >
                        {this.state.startDateView}
                      </label>
                    </div>
                  </div>
                </>
              )}

              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-2"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon
                      className="properties-img-2"
                      fileName="DateIcon"
                    />{" "}
                    <span className="pl-10 properties-span">End date</span>
                  </label>
                  <label
                    className={`properties-label ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  >
                    {this.state.endDateView}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                  isMobile ? "" : "pb-2"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon
                      className="properties-img-2"
                      fileName="UserIcon"
                    />{" "}
                    <span className="pl-10 properties-span">
                      Available vacancies
                    </span>
                  </label>
                  <label
                    className={`properties-label ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  >
                    {this.state.remainingVacancy}
                  </label>
                </div>
              </div>
              {this.state.additionalDateView.length > 0 &&
                this.state.isNonConsecutiveDatesView && (
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-2"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon
                          className="properties-img-2"
                          fileName="DateIcon"
                        />{" "}
                        <span className="pl-10 properties-span">
                          Training dates
                        </span>
                      </label>
                      {/* <label
                      className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                        }`}
                    >
                      {Array.isArray(this.state.additionalDateView) &&
                        this.state.additionalDateView.length > 0
                        ? this.state.additionalDateView
                          .map(date => moment(date).format("DD-MMM-YYYY"))
                          .join(", ")
                        : "-"}
                    </label> */}
                      <label
                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}
                      >
                        {Array.isArray(this.state.additionalDateView) &&
                        this.state.additionalDateView.length > 0
                          ? this.state.additionalDateView.map((date, index) => (
                              <div key={index} className="mb-1">
                                {moment(date).format("DD-MMM-YYYY")}
                              </div>
                            ))
                          : "-"}
                      </label>
                    </div>
                  </div>
                )}

              {/* EMployee Code Changes */}
              {this.state.employeeName != "" &&
                this.state.employeeCode != "" &&
                this.state.enrolledStatus === "Enrolled" && (
                  <>
                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                        isMobile ? "" : "pb-2"
                      } `}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 label-text ${
                            isMobile ? "pt-2" : ""
                          }`}
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="DateIcon"
                          />
                          <span className="pl-10 properties-span">
                            Employee name
                          </span>
                        </label>
                        <label
                          className={`properties-label ${
                            isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        >
                          {this.state.employeeName}
                        </label>
                      </div>
                    </div>
                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                        isMobile ? "" : "pb-2"
                      } `}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 label-text ${
                            isMobile ? "pt-2" : ""
                          }`}
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="VendorCodeIcon"
                          />
                          <span className="pl-10 properties-span">
                            Employee code
                          </span>
                        </label>
                        <label
                          className={`properties-label ${
                            isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                        >
                          {this.state.employeeCode}
                        </label>
                      </div>
                    </div>
                  </>
                )}
              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${
                  isMobile ? "" : "pb-2"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon
                      className="properties-img-2"
                      fileName="courseDescIcon"
                    />{" "}
                    <span className="pl-5 properties-span">
                      Course description
                    </span>
                  </label>
                  <label
                    className={`properties-label ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  >
                    {this.state.courseDiscription}{" "}
                  </label>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${
                  isMobile ? "" : "pb-2"
                } `}
              >
                <div className="form-group">
                  <label
                    className={`d-flex m-0 label-text ${
                      isMobile ? "pt-2" : ""
                    }`}
                  >
                    <CommonIcon
                      className="properties-img-2"
                      fileName="courseDescIcon"
                    />{" "}
                    <span className="pl-5 properties-span">
                      Training description
                    </span>
                  </label>
                  <label
                    className={`properties-label ${
                      isSmallMobile ? "mt-3 mb-2" : "mt-2"
                    }`}
                  >
                    {this.state.trainingDiscription}{" "}
                  </label>
                </div>
              </div>
              {UserRole.EMPLOYEE != currentUser &&
                apply_for === "Apply for others" && (
                  <>
                    <div
                      className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${
                        isMobile ? "" : "pb-2"
                      }`}
                    >
                      <div>
                        <label
                          className={`label-text ${
                            isMobile
                              ? "d-flex pt-2 mb-2-ledger"
                              : "d-flex mb-2-ledger"
                          }`}
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="CourseCodeIcon"
                          />{" "}
                          <span className="pl-10 properties-search-span">
                            Employee name
                          </span>
                          <span className="MuiFormHelperText-contained">*</span>
                        </label>
                        <Select
                          className={`text-12-normal-select my-input-class ${
                            this.state.employeeEmpty && "border-red"
                          }  `}
                          classNamePrefix="assigngroups"
                          placeholder="Please select an option"
                          styles={styles}
                          value={selectedOption}
                          options={this.state.employeeList}
                          defaultValue={"Select"}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          isClearable={true}
                          isMulti={true}
                          isSearchable={true}
                          onChange={this.handleSelectedChange}
                          //closecloseMenuOnSelect={false}
                        />
                        {this.state.employeeEmpty === true ? (
                          <span className="send-rework-label">
                            This field is required
                          </span>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </>
                )}
              {this.state.enrolledStatus === "Enrolled" &&
              this.state.currentUser === UserRole.EMPLOYEE ? (
                <></>
              ) : (
                <div
                  className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${
                    isMobile ? "" : "pb-2"
                  } `}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <CommonIcon
                        className="properties-img-2"
                        fileName="CommentIcon"
                      />{" "}
                      <span className="pl-5 properties-span">Comments</span>
                      <label className="required"></label>
                    </label>
                    <textarea
                      name="applyComments"
                      value={this.state.applyComments}
                      onChange={(e) => this.handleChange(e, "text")}
                      className={`text-wrap form-text-box2 resize-none border-radius-0 ${
                        isMobile
                          ? "form-control form-control-mobile"
                          : "form-control"
                      }`}
                      id="applyComments"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              )}
            </div>
            {/* {this.state.status != "Enrolled" && */}
            <div className="row mt-1">
              {UserRole.ADMIN === currentUser && (
                <div
                  className={`${
                    iswebMobile ? "col-12" : "col-4"
                  } col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3  ${
                    isMobile ? "mt-4" : "mt-2"
                  }`}
                >
                  <button
                    className={`btn btn-light input-group offcavasclose warning-btn p-2`}
                    onClick={this.backtoApplyTraining}
                  >
                    <CommonIcon
                      fileName="backButtonIcon"
                      className="modal-img"
                    />
                    <span className="send-rework-label pl-5">Back</span>
                  </button>
                </div>
              )}
              {this.state.enrolledStatus === "Enrolled" &&
              this.state.currentUser === UserRole.EMPLOYEE ? (
                <></>
              ) : (
                <div
                  className={`${
                    iswebMobile ? "col-12" : "col-4"
                  } col-sm-4 col-md-4 col-lg-4 col-xl-4 mb-3  ${
                    isMobile ? "mt-4" : "mt-2"
                  }`}
                >
                  <button
                    className={`btn btn-light input-group offcavasclose filter-nextbtn p-2`}
                    onClick={this.applyTraining}
                  >
                    <CommonIcon
                      fileName="ButtonSubmitIcon"
                      className="modal-img"
                    />
                    <span className="model-label pl-5">Apply</span>
                  </button>
                </div>
              )}
            </div>
            {/* } */}
          </div>
        </div>

        {/* Search Screen */}

        {
          <div
            className={` viewbar-search viewbarOpen display-hide`}
            id="searchScreen"
          >
            <div className="viewMain">
              <div className="viewTitle mb-2 px-4 pt-4">
                <h6 id="offcanvasRightLabel" className="modal-title fw-600">
                  Search
                </h6>
                <button
                  className={`text-reset offcavasclose buttonstyle ${
                    isMobile ? "pr-0" : "pr-0"
                  }`}
                  onClick={() => this.closeWithoutClearData()}
                >
                  <CommonIcon fileName="CrossIcon" />
                </button>{" "}
              </div>

              <div className="px-4 pt-0">
                <div className="row">
                  {/* <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                        <div className="form-group">
                                            <label className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""}`}>
                                                <CommonIcon fileName="requestId" /><span className="pl-5 properties-span-2">Request ID</span>
                                            </label>
                                            <input type="text" className="form-control form-text-box-search  records-editinput-class " value={this.state.searchInputData.trainingRequestId} onChange={(e) => this.handleInputchange(e, "trainingRequestId")} required />
                                        </div>
                                    </div> */}
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-3"
                    }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="CourseCodeIcon" />
                        <span className="pl-5 properties-span-2">
                          Course code
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-text-box-search  records-editinput-class"
                        value={this.state.searchInputData.courseCode}
                        onChange={(e) =>
                          this.handleInputchange(e, "courseCode")
                        }
                        required
                      />
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-3"
                    }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex label-text mb-1 ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="CourseTitleIcon" />
                        <span className="pl-5 properties-span-2">
                          Course title
                        </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-text-box-search  records-editinput-class`}
                        value={this.state.searchInputData.courseTitle}
                        onChange={(e) =>
                          this.handleInputchange(e, "courseTitle")
                        }
                        required
                      />
                    </div>
                  </div>

                  {/* <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                        <div className="form-group">
                                            <label className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""}`}>
                                                <CommonIcon fileName="VendorNameIcon" /><span className="pl-5 properties-span-2 ">Vendor</span>
                                            </label>
                                            <input type="text" className="form-control form-text-box-search  records-editinput-class" value={this.state.searchInputData.vendorName} onChange={(e) => this.handleInputchange(e, "vendorName")} required />
                                        </div>
                                    </div> */}
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-3"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="VendorNameIcon" />
                        <span className="pl-7 properties-span-2">Vendor</span>
                      </label>
                      <Select
                        className={`form-text-box-search records-editinput-class`}
                        classNamePrefix="assigngroups"
                        placeholder="Please select an option"
                        styles={styles}
                        value={this.state.selectVendorName}
                        options={this.state.vendorList}
                        defaultValue={this.state.selectVendorName || "Select"}
                        isClearable={true}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        isMulti={false}
                        isSearchable={true}
                        onChange={this.onchangeVendorName}
                      />
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-3"
                    }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="PropertiesIcon" />
                        <span className="pl-5 properties-span-2 ">Status</span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-text-box-search  records-editinput-class"
                        value={this.state.searchInputData.status}
                        onChange={(e) => this.handleInputchange(e, "status")}
                        required
                      />
                    </div>
                  </div>

                  {/* <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                        <div className="form-group">
                                            <label className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""}`}>
                                                <CommonIcon fileName="skillIcon" /><span className="pl-5 properties-span-2 ">Skills</span>
                                            </label>
                                            <input type="text" className="form-control form-text-box-search  records-editinput-class" value={this.state.searchInputData.skills} onChange={(e) => this.handleInputchange(e, "skills")} required />
                                        </div>
                                    </div> */}

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                      isMobile ? "" : "pb-3"
                    } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="skillIcon" />
                        <span className="pl-7 properties-span-2">Skill</span>
                      </label>
                      <Select
                        className={`form-text-box-search records-editinput-class ${
                          this.state.employeeNameEmpty && "border-red"
                        }  `}
                        classNamePrefix="assigngroups"
                        placeholder="Please select an option"
                        styles={styles}
                        value={this.state.selectSkillsName}
                        options={this.state.skillsList}
                        defaultValue={this.state.selectSkillsName || "Select"}
                        isClearable={true}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        isMulti={false}
                        isSearchable={true}
                        onChange={this.onchangeSkillName}
                      />
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6  ${
                      isRadioMobile ? "mt-3" : "mt-2"
                    } ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="">
                      <label
                        className={`d-flex label-text mb-2 ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="DateIcon" />
                        <span className="pl-5 properties-span-2">
                          Start date
                        </span>
                      </label>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          className="form-control f-12 records-editinput-class search-date"
                          emptyLabel="dd-mmm-yyyy"
                          keyboardIcon={
                            <label className="margin-top-0">
                              <CommonIcon fileName="calenderDate" />
                            </label>
                          }
                          format="dd-MMM-yyyy"
                          value={
                            this.state.searchInputData.startDate
                              ? this.state.searchInputData.startDate
                              : null
                          }
                          size="small"
                          onChange={(e) =>
                            this.handleInputchange(e, "startDate")
                          }
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6  ${
                      isRadioMobile ? "mt-3" : "mt-2"
                    } ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex label-text mb-2 ${
                          isMobile ? "pt-2" : ""
                        }`}
                      >
                        <CommonIcon fileName="DateIcon" />
                        <span className="pl-5 properties-span-2">End date</span>
                      </label>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          className="form-control f-12 records-editinput-class search-date"
                          emptyLabel="dd-mmm-yyyy"
                          keyboardIcon={<CommonIcon fileName="calenderDate" />}
                          format="dd-MMM-yyyy"
                          value={
                            this.state.searchInputData.endDate
                              ? this.state.searchInputData.endDate
                              : null
                          }
                          size="small"
                          onChange={(e) => this.handleInputchange(e, "endDate")}
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                  {this.state.currentUser === UserRole.ADMIN && (
                    <>
                      <div
                        className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                          isMobile ? "" : "pb-3"
                        }`}
                      >
                        <div className="form-group">
                          <label
                            className={`d-flex label-text mb-1 ${
                              isMobile ? "pt-2" : ""
                            }`}
                          >
                            <CommonIcon fileName="MyselfIcon" />
                            <span className="pl-5 properties-span-2">
                              Course status
                            </span>
                          </label>
                          <input
                            type="text"
                            className={`form-control form-text-box-search  records-editinput-class`}
                            value={this.state.searchInputData.activeStatus}
                            onChange={(e) => this.onChangeCourseStatus(e)}
                            required
                          />
                        </div>
                      </div>
                    </>
                  )}
                  {this.state.currentUser === UserRole.ADMIN && (
                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${
                        isMobile ? "" : "pb-3"
                      }`}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex label-text mb-1 ${
                            isMobile ? "pt-2" : ""
                          }`}
                        >
                          <CommonIcon fileName="MyselfIcon" />
                          <span className="pl-5 properties-span-2">
                            Training status
                          </span>
                        </label>
                        <input
                          type="text"
                          className={`form-control form-text-box-search  records-editinput-class`}
                          onChange={(e) =>
                            this.handleInputchange(e, "trainingStatus")
                          }
                          value={this.state.searchInputData.trainingStatus}
                          required
                        />
                      </div>
                    </div>
                  )}
                </div>
                {this.state.validationMsg ? (
                  <span className="properties-span-2 text-danger">
                    Atleast one field is mandatory
                  </span>
                ) : (
                  ""
                )}
                <div className="d-flex mt-20">
                  <button
                    className={`btn rejectbutton d-flex gap-1`}
                    onClick={() => this.clearSearchDetails()}
                  >
                    <span>
                      <CommonIcon fileName="clearIcon1" />
                    </span>
                    <span className="pl-vendor3 pl-2">Clear</span>
                  </button>
                  <button
                    className={`btn approvebutton ml-10 d-flex gap-1`}
                    onClick={() => this.validateSearchRecords()}
                  >
                    <span className="">
                      <CommonIcon fileName="searchableIcon" />
                    </span>
                    <span className="model-label pl-vendor3 pl-2">Search</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        }

        {/* Modal - Warning */}
        <WarningComponent
          message={
            this.state.isRemovePopUp
              ? "Are you sure you want to remove the training ?"
              : "There are active training requests associated with this training calendar.\n Do you still want to proceed with inactivating it?"
          }
          isMobile={this.state.isMobile}
          onYesClick={
            this.state.isRemovePopUp
              ? this.removeupcomingTraining
              : this.saveTrainingWithoutValidation
          }
        />

        {/* Pagination */}
        <PaginationComponent
          fetchPagination={this.fetchPaginationList}
          pageCount={pageCount}
          reset={this.state.pageNewCount}
        />
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UpcomingTainings),
);
